export default __webpack_public_path__ + "static/kontaktid_tartu-cf0b9b87b3d03aa9169361bfb10c5e6c.svg";